<div class="blocked-container width-660">
    <div class="blocked-intro-text" [innerHTML]="tipTitle | translate | punctuationWrap"></div>
    <h2 class="blocked-title" [innerHTML]="title | translate | punctuationWrap"></h2>
    <div class="json-container" [class.blocked-large-image]="isImageLarge" [class.json-container]="imageUrl.includes('json')" [class.svg-container]="imageUrl.includes('svg')">
        <ng-container *ngIf="imageUrl.includes('json')">
            <div id="jsonImageIcon" class="lottie" style="width:350px;"></div>
        </ng-container>
        <ng-container *ngIf="imageUrl.includes('svg')">
            <div id="jsonImageIcon"><img src="{{imageUrl}}" alt=""></div>
        </ng-container>
        
    </div>
    <div class="blocked-content" [innerHTML]="desc | translate | punctuationWrap"></div>
</div>
<ng-container *ngIf="isCtaVisible">
    <app-cta-container [primaryBtnLabel]="primaryButtonText | translate"
        [isPrimaryBtnBlue]="isPrimaryBtnBlue" [isSecondaryBtnHidden]="!isSecondaryButtonVisible" (actionSelected)="nextAction($event)"
        adobeSubmitTriggerClass='ab-error-screen'>
    </app-cta-container>
</ng-container>
